<template>
  <div class="modal-preview" v-show="opened">
    <div class="modal-preview-content shadow-sm">
      <top-bar title="Lista" url="/listas" class="d-print-none"/>
      <loading :fullscrean="true" v-if="load" text="Buscando a lista"/>
      <div class="container" v-else-if="!preview" style="max-width: 600px">
        <c-offline v-if="offline"/>
        <div class="alert alert-warning text-center" v-else>Lista não encontrada</div>
      </div>
      <div class="container" style="max-width: 600px; margin-bottom: 98px" v-else>
        <div class="preview-shell">
          <div class="preview-shell__header">
            <div class="preview-shell__eyebrow">Visualização da lista</div>
            <div class="preview-shell__meta">
              <span class="preview-shell__chip">Regional {{ regional.nome_regional }}</span>
              <span class="preview-shell__chip">{{ meses.find(m => m.valor == preview.mes_lista).mes }} de {{ preview.ano_lista }}</span>
            </div>
          </div>

          <div class="preview">
            <div class="text-center mb-3">
            <h5 class="mb-1 font-weight-bold">CONGREGAÇÃO CRISTÃ NO BRASIL</h5>
            <h6 class="mb-1 font-weight-bold">REGIONAL {{ regional.nome_regional }} - {{ meses.find(m => m.valor == preview.mes_lista).mes }} de {{ preview.ano_lista }}</h6>
            <h6 class="mb-0 font-weight-bold">{{ preview.nome_lista }}</h6>
            </div>

            <categoria-preview v-for="cat in preview.categorias" :key="cat.id_lista_categoria || cat.nome_categoria" :cat="cat"/>

            <div class="border mt-2" v-for="a in preview.avisos">
              <div class="title">
                {{a.titulo}}
              </div>
              <div class="message" v-html="a.mensagem"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="fixed-bottom preview-actions border-top py-3 shadow-top d-print-none">
        <div class="container text-center preview-actions__inner">
          <button class="btn btn-outline-primary mr-2 preview-actions__button" @click="abrirLista()" :disabled="!preview">
            <i class="fa-solid fa-arrows-rotate mr-1"></i> Sincronizar
          </button>
          <button class="btn btn-outline-primary preview-actions__button" @click="compartilhar()" :disabled="!preview">
            <i class="fa-solid fa-share-nodes mr-1"></i> Compartilhar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import Loading from "@/components/Loading";
import COffline from "@/components/COffline";
import CategoriaPreview from "@/components/listas/CategoriaPreview";

export default {
  name: "ListaPreview",
  components: {CategoriaPreview, COffline, Loading, TopBar},
  props: ['meses'],
  data() {
    return {
      load: false,
      offline: false,
      id_lista: null,
      preview: null,
      opened: false
    }
  },

  methods: {

    closeModal() {
      document.body.classList.remove("modal-open");
      this.opened = false;
      this.$emit('closeModal');
    },

    abrirLista() {
      this.load = true;
      this.preview = null;
      let url = `listas/${this.id_lista}/preview?lista=true&app=1`;

      if (this.isLogged) {
        if (this.user.id_setor) {
          url += `&id_setor=${this.user.id_setor}`;
        }

        if (this.user.id_cidade) {
          url += `&id_cidade=${this.user.id_cidade}`;
        }
      }

      this.$http.get(url)
        .then(response => {
          this.load = false;

          if (response.data && response.data.id_lista) {
            this.preview = response.data;
            localStorage.setItem(url, JSON.stringify(this.preview));
          }

        }, res => {
          this.load = false;
          const data = localStorage.getItem(url);

          if (data) {
            this.preview = JSON.parse(data);

          } else {
            this.offline = true;
          }
        });
    },

    compartilhar() {
      try {
        navigator.share({
          title: `Lista de Batismo`,
          text: `Lista de Batismo Regional ${this.regional.nome_regional.toUpperCase()} - ${this.meses.find(m => m.valor == this.preview.mes_lista).mes} de ${this.preview.ano_lista}`,
          url: window.location.href,
        });

      } catch (err) {
        this.$swal('Dispositivo incompatível com o compartilhamento de lista.');
      }
    }
  },

  created() {
    this.$parent.$on('openModal', (id_lista) => {
      document.body.classList.add("modal-open");
      this.opened = true;
      this.id_lista = id_lista;
      this.abrirLista();
    });

    this.$parent.$on('closeModal', () => {
      this.closeModal();
    });
  },

  computed: {
    user() {
      return this.$store.state.user;
    },

    isLogged() {
      return !!this.user.id_membro;
    },

    regional() {
      return this.$store.state.dados.regional
    }
  },

  filters: {
    dia(d) {
      switch (d) {
        case 0: return "Seg";
        case 1: return "Ter";
        case 2: return "Qua";
        case 3: return "Qui";
        case 4: return "Sex";
        case 5: return "Sáb";
        case 6: return "Dom";
        default: return "";
      }
    }
  }
}
</script>

<style>
.modal-preview {
  display: block;
  position: fixed; /* Stay in place */
  z-index: 1040; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: var(--overlay-backdrop);
}

.modal-preview-content {
  background-color: var(--bg-theme);
  position: relative;
  overflow: auto;
  min-height: 100%;
  height: 100vh;
  width: 100%;
  margin: 0;
  border-radius: 0;
}

.preview-shell {
  margin-top: 14px;
  margin-bottom: 24px;
}

.preview-shell__header {
  margin-bottom: 12px;
}

.preview-shell__eyebrow {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-theme-secondary);
  margin-bottom: 10px;
}

.preview-shell__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.preview-shell__chip {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  background: var(--bg-theme-secondary);
  border: 1px solid var(--border-color);
  color: var(--text-theme-secondary);
  font-size: 12px;
  font-weight: 700;
}

.preview {
  margin-top: 5px;
  text-transform: uppercase;
  margin-bottom: 62px;
  width: 100%;
  padding: 18px 16px 22px;
  border-radius: 24px;
  background: var(--bg-theme-secondary);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-soft);
}

.preview table {
  width: 100%;
  border-collapse: collapse;
}

.preview h5 {
  font-size: 1.25em;
}

.preview h6 {
  font-size: 0.8em;
}

.preview .border {
  border-color: var(--preview-border-color)!important;
}

.preview .title, .preview .message {
  font-size: 0.9em;
  border-color: var(--preview-border-color);
}

.preview .message {
  text-align: justify;
  padding: 6px 4px;
}

.preview .message p {
  margin-bottom: 4px;
}

.preview .message p:last-child {
  margin-bottom: 0;
}

.preview .title {
  font-size: 1.3em;
  text-align: center;
  border-bottom: 1px solid var(--preview-border-color);
  font-weight: bold;
  background-color: var(--preview-header-bg);
  padding: 2px 0;
  position: relative;
}

.preview td {
  vertical-align: middle!important;
  font-size: 0.8em;
  border-color: var(--preview-border-color)!important;
  padding: 0.1rem!important;
}

.preview th {
  font-size: 0.7em;
  border-color: var(--preview-border-color)!important;
  padding: 0!important;
}

.preview tr:nth-child(odd) td {
  background-color: var(--preview-row-alt-bg) !important;
  -webkit-print-color-adjust: exact;
}

.preview .anciao {
  white-space: nowrap;
  font-size: 0.7em;
}

.preview .dia {
  text-align: center;
  text-transform: none;
  white-space: nowrap;
}

.preview .libras {
  float: right;
  width: 15px;
  margin-top: 1px;
}

.preview.copia-2 .dia {
  text-align: left;
}

.preview table {
  color: var(--text-theme);
}

.preview-actions {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(14px);
}

.preview-actions__inner {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.preview-actions__button {
  min-width: 146px;
}

.dark-mode .preview-actions {
  background: rgba(29, 42, 60, 0.92);
}

@media print {
  .preview {
    max-width: none;
    padding: 12px 0;
  }
}

@media (max-width: 767px) {
  .preview {
    padding: 14px 10px 18px;
    border-radius: 20px;
  }

  .preview-actions__inner {
    flex-direction: column;
  }

  .preview-actions__button {
    width: 100%;
    min-width: 0;
    margin-right: 0 !important;
  }
}
</style>
